import React from "react"
import { motion, AnimatePresence } from "framer-motion"

import LoadingIcon from "../global/loading"

const AddToCartWithQuantitySelector = React.forwardRef(
  (
    {
      quantity,
      setQuantity,
      handleAddToCart,
      available,
      loading,
      mode,
      setMode,
    },
    ref
  ) => (
    <div className="product__atc-container" ref={ref}>
      <AnimatePresence exitBeforeEnter>
        {mode === 0 && (
          <motion.button
            key="qty"
            className="product__qty-button h2"
            disabled={loading || !available}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setMode(1)}
          >
            {available ? "Select Quantity" : "Sold Out"}
          </motion.button>
        )}
        {mode === 1 && (
          <motion.div
            key="atc"
            className="product__atc h2"
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div>
              <span>Quantity:</span>
              <button
                title={"Decrease Quantity"}
                onClick={() => setQuantity(quantity - 1)}
              >
                -
              </button>
              <input
                type="number"
                name="Quantity"
                value={quantity}
                onChange={e => setQuantity(e.target.value)}
              />
              <button
                title={"Decrease Quantity"}
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
            <button
              className="button__atc"
              disabled={loading || !available}
              title="Add to Cart"
              onClick={handleAddToCart}
            >
              <AnimatePresence exitBeforeEnter>
                {loading ? (
                  <motion.div
                    key={"loading"}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <LoadingIcon />
                  </motion.div>
                ) : (
                  <motion.div
                    key="add"
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <span>Add</span>
                  </motion.div>
                )}
              </AnimatePresence>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
)

export default AddToCartWithQuantitySelector
